/* CasaRosa Recently Viewed (Phase 4)
   - Tracks product card clicks into localStorage (key: cr_recently_viewed)
   - Keeps up to 12 items, newest first
   - Renders the rail on any page containing [data-cr-recently-viewed]
*/
(function () {
  var STORAGE_KEY = 'cr_recently_viewed';
  var MAX_ITEMS = 12;

  function getViewed() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) { return []; }
  }

  function saveViewed(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
  }

  function trackProduct(product) {
    if (!product || !product.id) return;
    var items = getViewed().filter(function (p) { return p.id !== product.id; });
    items.unshift(product);
    if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
    saveViewed(items);
  }

  function readCard(card) {
    var id = card.getAttribute('data-product-id');
    if (!id) return null;
    var link = card.querySelector('a[href*="/products/"]');
    var img = card.querySelector('img');
    var titleEl = card.querySelector('.cr-prod-card__title-link, .cr-prod-card__name, h3 a, .card-title, .cr-prod-card__title');
    var priceEl = card.querySelector('[data-cr-price], .price-item--regular, .cr-prod-card__price, .price__regular .price-item');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var price = priceEl ? priceEl.textContent.trim() : '';
    var url = link ? link.getAttribute('href') : '';
    var image = img ? (img.getAttribute('src') || img.getAttribute('data-src') || '') : '';
    if (!title || !url) return null;
    return { id: id, title: title, url: url, image: image, price: price };
  }

  function hookCardClicks() {
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('[data-cr-card]');
      if (!card) return;
      var p = readCard(card);
      if (p) trackProduct(p);
    }, true);
  }

  function escapeHtml(str) {
    if (str == null) return '';
    var div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  function renderRail() {
    var container = document.querySelector('[data-cr-recently-viewed]');
    if (!container) return;
    var currentId = container.getAttribute('data-current-product-id');
    var items = getViewed().filter(function (p) { return !currentId || p.id !== currentId; });
    if (items.length === 0) { container.style.display = 'none'; return; }
    var list = container.querySelector('[data-cr-recently-viewed-list]');
    if (!list) return;
    list.innerHTML = items.map(function (p) {
      return '<a class="cr-recent__item" href="' + escapeHtml(p.url) + '">' +
        '<div class="cr-recent__media">' +
          (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="cr-recent__name">' + escapeHtml(p.title) + '</div>' +
        (p.price ? '<div class="cr-recent__price">' + escapeHtml(p.price) + '</div>' : '') +
      '</a>';
    }).join('');
    container.style.display = '';
  }

  function init() { hookCardClicks(); renderRail(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
